import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * 페이지 이동 시 화면을 부드럽게 최상단으로 스크롤해주는 컴포넌트
 * App.js에서 Router 내부에 배치하여 사용
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // pathname이 변경될 때마다 실행
    // window.scrollTo({ top: 0, behavior: 'smooth' }) 대신
    // 컨텐츠 영역을 찾아서 스크롤
    const contentWrapper = document.querySelector('.content-wrapper');
    if (contentWrapper) {
      contentWrapper.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    } else {
      // 컨텐츠 래퍼가 없으면 window에 스크롤 적용
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  }, [pathname]);

  return null;
};

export default ScrollToTop; 